import styled from 'styled-components';
export const StyledVoiceoverInput = styled.div`
  z-index: 101;
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  -webkit-backdrop-filter: blur(10px);
  -moz-backdrop-filter: blur(10px);
  -ms-backdrop-filter: blur(10px);
  -o-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  position: absolute;
  width: ${({ theme }) => theme.hudPanelWidth};
  min-width: ${({ theme }) => theme.hudPanelWidth};
  max-width: ${({ theme }) => theme.hudPanelMaxWidth};
  right: ${({ theme }) => theme.frameOffset};
  top: ${({ theme }) => theme.navHeight};
  animation: popup-animation-translate 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0s 1 normal forwards, popup-animation-opacity 0.1s cubic-bezier(0.5, 0.35, 0, 1) 0s 1 normal forwards;
  transform-origin: 100% 0;
  transform: scale(var(--app-scale));

  .voiceover-input-content-wrapper {
    width: 100%;
    height: 100%;
  }

  .voiceover-input-gen-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    img {
      width: 24px;
      padding-bottom: 6px;
    }
  }
  
  .voiceover-input-title-holder {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 12px;
    width: 100%;
    margin-bottom: 24px;

    @media (max-height: 600px) {
      margin-bottom: 1rem;
    }
  }

  .voiceover-input-logo {
    width: 24px;
    height: 24px;
  }

  .voiceover-input-title {
    font-family: "NeueMachina";
    font-size: 1.5em;
    line-height: 1.2;
    font-weight: 800;
    color: white;
    text-transform: uppercase;
  }

  .voiceover-input-content {
    width: 100%;
    height: 100%;
    border: 2px solid rgba(0, 0, 0, 0.36);
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
    padding: 32px 32px 48px 32px;

    @media (max-height: 600px) {
      padding: 16px 16px 32px 16px;
    }
  }
  
  .voiceover-input-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;
  }

  .voiceover-input-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .voiceover-input-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .voiceover-input-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .voiceover-input-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }

  .voiceover-input-stats {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0;
  }

  .voiceover-input-stat-dropdown {
    max-width: 60%;
    width: 60%;
  }

  .voiceover-input-stat-counter {
    max-width: 40%;
    font-family: "BebasNeue";
    font-size: 1.5rem;
    line-height: 1.5rem;
    font-weight: 400;

    span {
      opacity: 0.4;
    }
  }

  .voiceover-powered-by {
    font-family: "BebasNeue";
    font-size: 1.25em;
    color: white;
    padding-top: 4px;
    text-align: end;
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding-right: 24px;
    @media (max-height: 600px) {
      padding-right: 16px;
    }
  }

  .voiceover-powered-by-label {
    opacity: 0.4;
    margin-right: 5px;
  }

  .voiceover-elevenlabs-logo {
    font-family: Inter,sans-serif;
    font-weight: 700;
  }

  .voiceover-input-api-key-holder {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .voiceover-input-api-key-label {
    font-family: "BebasNeue";
    font-size: 1.5rem;
    line-height: 1.5rem;
    font-weight: 400;
  }

  .voiceover-input-api-key {
    font-family: "NeueMachina";
    font-size: 1.5rem;
    line-height: 1.5rem;
    font-weight: 400;
    opacity: 0.4;
  }

  .voiceover-input-api-key-edit-button {
    cursor: pointer;
    width: ${({ theme }) => theme.iconSize};
    height: ${({ theme }) => theme.iconSize};
  }

  .voiceover-input-api-key-hint {
    font-family: "BebasNeue";
    font-size: 1.5rem;
    line-height: 1.5rem;
    font-weight: 400;
  }

  .voiceover-input-api-key-section {
    margin-top: 24px;
    margin-bottom: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-height: 600px) {
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
  }
`;
